import clsx from "clsx";
import Link, { LinkProps } from "next/link";
import { createRouteFromParams } from "@/src/helpers/createRouteWithParams";
import { ROUTE_GALLERY_COLLECTION_LISTING } from "@/constants/routes";
import { PropsWithChildren } from "react";
import { algoliaIndexNames } from "@/src/routes/gallery/routes/collections/routes/[collectionName]/constants";
import { TokenProperty } from "../../ProductTabs/types";

export type PropertyProps = PropsWithChildren<{
  tokenProperty: TokenProperty;
  collectionSlug: string;
  className?: string;
}> &
  Omit<LinkProps, "href">;

export function createFilterTraitsSearchQuery(
  traitType: TokenProperty["traitType"],
  value: TokenProperty["value"],
) {
  return encodeURI(
    `?${
      algoliaIndexNames.main
    }[refinementList][filterTraits.${traitType.toLowerCase()}][0]=${
      typeof value === "string" ? value.toLowerCase() : value
    }`,
  );
}

export function PropertyCollectionLink({
  tokenProperty,
  className,
  children,
  collectionSlug,
  ...props
}: PropertyProps) {
  return (
    <Link
      shallow
      href={{
        pathname: createRouteFromParams(ROUTE_GALLERY_COLLECTION_LISTING, {
          collectionName: collectionSlug,
        }),
        search: createFilterTraitsSearchQuery(
          tokenProperty.traitType,
          tokenProperty.value,
        ),
      }}
      className={clsx(
        "border-gray-500 text-gray-350 border p-2.5 betterhover:hover:border-green-500",
        className,
      )}
      aria-label={`View all tokens with ${tokenProperty.traitType}: ${tokenProperty.value}`}
      {...props}
    >
      {children}
    </Link>
  );
}
